/**
 * Cart Drawer & Mobile Menu Cross-Sell UI Controller (design-system: commerce/drawer-cart)
 * All recommendation curation, school scoping, grade-level filtering, brand affinity,
 * unfulfilled-category prioritization, and card rotation execute strictly server-side
 * in Shopify Liquid. This controller handles only UI interactions (carousel scroll,
 * variant selection, 1-tap Add to Cart, and silent session context sync).
 */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') { return; }

  function getKitBoxes() {
    return document.querySelectorAll('[data-ds-cart-kit], [data-ds-cart-reco], [data-mmenu-upsell]');
  }

  function getPrimaryKitBox(trigger) {
    if (trigger && trigger.closest) {
      var scopedParent = trigger.closest('#mini-cart, [data-section-type="cart"]');
      if (scopedParent) {
        var scopedBox = scopedParent.querySelector('[data-ds-cart-kit]');
        if (scopedBox) { return scopedBox; }
      }
    }
    var miniCart = document.getElementById('mini-cart');
    if (miniCart && miniCart.getAttribute('aria-hidden') === 'false') {
      var drawerBox = miniCart.querySelector('[data-ds-cart-kit]');
      if (drawerBox) { return drawerBox; }
    }
    return document.querySelector('[data-section-type="cart"] [data-ds-cart-kit]') || document.querySelector('#mini-cart [data-ds-cart-kit]') || document.querySelector('[data-ds-cart-kit]') || document.querySelector('[data-ds-cart-reco]');
  }

  // Silently sync opaque server-side context tokens or clear stale school context
  function syncServerContext(callback) {
    try {
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      var clearEls = document.querySelectorAll('[data-clear-ks]');
      if (clearEls.length > 0) {
        for (var c = 0; c < clearEls.length; c++) {
          clearEls[c].removeAttribute('data-clear-ks');
        }
        fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { _ks: '' } })
        }).then(function () {
          if (typeof callback === 'function') { callback(); }
        }).catch(function () {
          if (typeof callback === 'function') { callback(); }
        });
        return;
      }

      var el = document.querySelector('[data-sync-ks], [data-sync-kv]');
      if (!el) {
        if (typeof callback === 'function') { callback(); }
        return;
      }
      var ks = el.getAttribute('data-sync-ks') || '';
      var kv = el.getAttribute('data-sync-kv') || '';
      if (!ks && !kv) {
        if (typeof callback === 'function') { callback(); }
        return;
      }

      el.removeAttribute('data-sync-ks');
      el.removeAttribute('data-sync-kv');

      var attrs = {};
      if (ks) { attrs._ks = ks; }
      if (kv) { attrs._kv = kv; }

      fetch(rootUrl + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function () {
        if (typeof callback === 'function') { callback(); }
      }).catch(function () {
        if (typeof callback === 'function') { callback(); }
      });
    } catch (e) {
      if (typeof callback === 'function') { callback(); }
    }
  }

  var isFetchingHeader = false;
  function syncHeaderMobileMenu() {
    if (isFetchingHeader) { return; }
    isFetchingHeader = true;
    try {
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      fetch(rootUrl + '?section_id=header&_t=' + Date.now(), {
        credentials: 'same-origin',
        headers: { 'Cache-Control': 'no-cache' }
      }).then(function (res) {
        if (!res.ok) { throw new Error('Header fetch failed'); }
        return res.text();
      }).then(function (headerHtml) {
        refreshMobileMenuKit(headerHtml);
      }).catch(function () {}).finally(function () {
        isFetchingHeader = false;
      });
    } catch (err) {
      isFetchingHeader = false;
    }
  }

  function updateSegmentArrows(scroller) {
    if (!scroller) { return; }
    var segment = scroller.closest ? scroller.closest('.ds-cart-kit__segment') : null;
    if (!segment) { return; }
    var prevBtn = segment.querySelector('[data-segment-nav="prev"]');
    var nextBtn = segment.querySelector('[data-segment-nav="next"]');
    if (!prevBtn || !nextBtn) { return; }

    var atStart = scroller.scrollLeft <= 4;
    var atEnd = (scroller.scrollLeft + scroller.clientWidth) >= (scroller.scrollWidth - 6);
    var hasOverflow = scroller.scrollWidth > (scroller.clientWidth + 6);

    if (!hasOverflow) {
      prevBtn.style.visibility = 'hidden';
      nextBtn.style.visibility = 'hidden';
    } else {
      prevBtn.style.visibility = 'visible';
      nextBtn.style.visibility = 'visible';
      prevBtn.classList.toggle('ds-cart-kit__arrow--disabled', atStart);
      nextBtn.classList.toggle('ds-cart-kit__arrow--disabled', atEnd);
    }
  }

  function refreshAllKitInstances() {
    var boxes = getKitBoxes();
    for (var b = 0; b < boxes.length; b++) {
      var scrollers = boxes[b].querySelectorAll('.ds-cart-kit__segment-products');
      for (var i = 0; i < scrollers.length; i++) {
        updateSegmentArrows(scrollers[i]);
      }
    }
  }

  // 1. Interactive jump-to-segment on Cart Drawer or Cart Page checklist chip / promo banner tap
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('.ds-cart-kit__chip:not([data-mmenu-jump]), [data-jump-to-kit]') : null;
    if (!trigger) { return; }
    var cat = trigger.getAttribute('data-chip') || trigger.getAttribute('data-jump-to-kit') || 'shoes';

    var box = getPrimaryKitBox(trigger);
    if (!box) { return; }

    var targetSegment = box.querySelector('[data-segment="' + cat + '"]') || box.querySelector('[data-segment="shoes"]') || box.querySelector('.ds-cart-kit__segment');
    if (targetSegment) {
      e.preventDefault();
      targetSegment.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      targetSegment.classList.add('ds-cart-kit__segment--highlight');
      setTimeout(function () {
        targetSegment.classList.remove('ds-cart-kit__segment--highlight');
      }, 1500);
    }
  });

  // 1b. Mobile Menu cross-sell quick-jump to stacked category segment
  document.addEventListener('click', function (e) {
    var mmenuJump = e.target.closest ? e.target.closest('[data-mmenu-jump]') : null;
    if (!mmenuJump) { return; }

    var jumpCat = mmenuJump.getAttribute('data-mmenu-jump') || 'shoes';
    var mmenuContainer = document.getElementById('ds-mmenu-upsell');
    if (mmenuContainer) {
      e.preventDefault();
      var targetSegment = mmenuContainer.querySelector('[data-segment="' + jumpCat + '"]') || mmenuContainer.querySelector('.ds-cart-kit__segment');
      if (targetSegment) {
        targetSegment.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        targetSegment.classList.add('ds-cart-kit__segment--highlight');
        setTimeout(function () {
          targetSegment.classList.remove('ds-cart-kit__segment--highlight');
        }, 1500);
      } else {
        mmenuContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  });

  // 2. Horizontal arrow navigation for kit segments
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest ? e.target.closest('[data-segment-nav]') : null;
    if (!arrow || arrow.classList.contains('ds-cart-kit__arrow--disabled')) { return; }
    var segment = arrow.closest('.ds-cart-kit__segment');
    if (!segment) { return; }
    var scroller = segment.querySelector('.ds-cart-kit__segment-products');
    if (!scroller) { return; }

    e.preventDefault();
    var dir = arrow.getAttribute('data-segment-nav');
    var scrollByDistance = Math.max(180, scroller.clientWidth * 0.75);
    scroller.scrollBy({
      left: dir === 'next' ? scrollByDistance : -scrollByDistance,
      behavior: 'smooth'
    });
  });

  // 3. Dynamically update segment arrow states during scroll
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('ds-cart-kit__segment-products')) {
      updateSegmentArrows(e.target);
    }
  }, true);

  // 4. Desktop mouse drag-to-scroll support for horizontal carousels
  var dragState = { active: false, scroller: null, startX: 0, scrollLeft: 0, moved: false };
  document.addEventListener('mousedown', function (e) {
    if (e.button !== 0) { return; }
    if (e.target.closest && e.target.closest('select, button, input')) { return; }
    var scroller = e.target.closest ? e.target.closest('.ds-cart-kit__segment-products') : null;
    if (!scroller) { return; }
    dragState.active = true;
    dragState.scroller = scroller;
    dragState.startX = e.pageX - scroller.offsetLeft;
    dragState.scrollLeft = scroller.scrollLeft;
    dragState.moved = false;
  });

  document.addEventListener('mousemove', function (e) {
    if (!dragState.active || !dragState.scroller) { return; }
    var x = e.pageX - dragState.scroller.offsetLeft;
    var walk = (x - dragState.startX) * 1.4;
    if (Math.abs(walk) > 6) {
      dragState.moved = true;
      dragState.scroller.classList.add('is-dragging');
      dragState.scroller.scrollLeft = dragState.scrollLeft - walk;
    }
  });

  document.addEventListener('mouseup', function () {
    if (!dragState.active) { return; }
    if (dragState.scroller) {
      dragState.scroller.classList.remove('is-dragging');
    }
    dragState.active = false;
    dragState.scroller = null;
  });

  document.addEventListener('click', function (e) {
    if (dragState.moved) {
      var inScroller = e.target.closest ? e.target.closest('.ds-cart-kit__segment-products') : null;
      if (inScroller && !(e.target.closest && e.target.closest('select, [data-reco-add]'))) {
        e.preventDefault();
        e.stopPropagation();
      }
      dragState.moved = false;
    }
  }, true);

  // 5. Inline variant selector change -> update card price, image & Add button variant ID
  document.addEventListener('change', function (e) {
    var select = e.target.closest ? e.target.closest('[data-reco-variant-select]') : null;
    if (!select) { return; }
    var card = select.closest('.ds-cart-kit__product');
    if (!card) { return; }

    var selectedOption = select.options[select.selectedIndex];
    var newVariantId = select.value;
    card.setAttribute('data-variant-id', newVariantId);

    var addBtn = card.querySelector('[data-reco-add]');
    if (addBtn) {
      addBtn.setAttribute('data-variant-id', newVariantId);
    }

    var hiddenId = card.querySelector('[data-reco-hidden-id]');
    if (hiddenId) {
      hiddenId.value = newVariantId;
    }

    var priceEl = card.querySelector('[data-reco-price]');
    if (priceEl && selectedOption) {
      var priceStr = selectedOption.getAttribute('data-price');
      var compareStr = selectedOption.getAttribute('data-compare');
      var hasCompare = selectedOption.getAttribute('data-has-compare') === 'true';
      if (priceStr) {
        if (hasCompare && compareStr) {
          priceEl.innerHTML = '<span class="ds-cart-kit__price-sale">' + priceStr + '</span> <s class="ds-cart-kit__price-compare">' + compareStr + '</s>';
        } else {
          priceEl.textContent = priceStr;
        }
      }
    }

    var imgEl = card.querySelector('.ds-cart-kit__img');
    if (imgEl && selectedOption) {
      var newImgUrl = selectedOption.getAttribute('data-image');
      if (newImgUrl) {
        imgEl.setAttribute('src', newImgUrl);
      }
    }
  });

  // Screen reader announcement region for quick-add feedback (WCAG 4.1.3)
  function announce(message) {
    var region = document.getElementById('ds-cart-reco-status');
    if (!region) {
      region = document.createElement('div');
      region.id = 'ds-cart-reco-status';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      region.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
      document.body.appendChild(region);
    }
    region.textContent = '';
    window.setTimeout(function () { region.textContent = message; }, 60);
  }

  // Throttled arrow-state refresh: at most one layout read per animation frame
  var refreshScheduled = false;
  function scheduleRefresh() {
    if (refreshScheduled) { return; }
    refreshScheduled = true;
    window.requestAnimationFrame(function () {
      refreshScheduled = false;
      refreshAllKitInstances();
    });
  }

  // Swap the server-rendered mobile menu kit with fresh markup from the bundled Section Rendering response
  function refreshMobileMenuKit(headerHtml) {
    if (!headerHtml || typeof DOMParser === 'undefined') { return; }
    try {
      var doc = new DOMParser().parseFromString(headerHtml, 'text/html');

      var freshKit = doc.getElementById('ds-mmenu-upsell');
      var currentKit = document.getElementById('ds-mmenu-upsell');
      if (freshKit && currentKit && currentKit.parentNode) {
        var scrollMemory = {};
        var oldScrollers = currentKit.querySelectorAll('[data-segment-products]');
        for (var i = 0; i < oldScrollers.length; i++) {
          scrollMemory[oldScrollers[i].getAttribute('data-segment-products')] = oldScrollers[i].scrollLeft;
        }
        freshKit.removeAttribute('data-sync-ks');
        freshKit.removeAttribute('data-sync-kv');
        var adoptedKit = document.importNode(freshKit, true);
        currentKit.parentNode.replaceChild(adoptedKit, currentKit);
        var newScrollers = adoptedKit.querySelectorAll('[data-segment-products]');
        for (var j = 0; j < newScrollers.length; j++) {
          var key = newScrollers[j].getAttribute('data-segment-products');
          if (scrollMemory[key]) { newScrollers[j].scrollLeft = scrollMemory[key]; }
        }
      }

      var freshHub = doc.querySelector('.ds-mmenu-hub');
      var currentHub = document.querySelector('.ds-mmenu-hub');
      if (freshHub && currentHub && currentHub.parentNode) {
        currentHub.parentNode.replaceChild(document.importNode(freshHub, true), currentHub);
      }

      scheduleRefresh();
    } catch (err) {}
  }

  // 6. Delegated 1-tap Add to Cart: route prefix, bundled Section Rendering for the mobile menu, HTTP 422 guard
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-reco-add]') : null;
    if (!btn || btn.disabled) { return; }
    e.preventDefault();

    var card = btn.closest ? btn.closest('.ds-cart-kit__product, .ds-search-kit__card') : null;
    var select = card ? card.querySelector('[data-reco-variant-select]') : null;
    var variantId = parseInt((select && select.value) || btn.getAttribute('data-variant-id'), 10);
    if (!variantId) { return; }

    var inMobileMenu = !!(btn.closest && btn.closest('#ds-mmenu-upsell'));
    var nameEl = card ? card.querySelector('.ds-cart-kit__name, .ds-search-kit__name') : null;
    var productName = nameEl ? nameEl.textContent.trim() : 'Item';

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding…';

    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    var payload = { items: [{ id: variantId, quantity: 1 }] };
    if (inMobileMenu) {
      payload.sections = 'header';
      payload.sections_url = window.location.pathname + window.location.search;
    }

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (errData) {
          var err = new Error(errData.description || errData.message || 'Out of stock');
          err.status = r.status;
          throw err;
        });
      }
      return r.json();
    }).then(function (data) {
      btn.textContent = 'Added ✓';
      btn.setAttribute('aria-busy', 'false');
      announce(productName + ' added to cart');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { scrollToTop: false }
      }));
      if (inMobileMenu && data && data.sections && data.sections.header) {
        window.setTimeout(function () { refreshMobileMenuKit(data.sections.header); }, 900);
      }
    }).catch(function (err) {
      var isStockError = !!(err && err.status === 422);
      btn.textContent = isStockError ? 'Max Stock' : 'Retry';
      btn.setAttribute('aria-busy', 'false');
      announce(isStockError ? ((err && err.message) || 'No more stock available for this item') : 'Could not add to cart, please try again');
      window.setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    });
  });

  // Re-initialize arrow states and sync mobile menu on cart and drawer events
  document.addEventListener('cart:refresh', function () {
    window.setTimeout(function () {
      scheduleRefresh();
      syncServerContext(syncHeaderMobileMenu);
    }, 150);
  });
  document.addEventListener('cart:updated', function () {
    window.setTimeout(function () {
      scheduleRefresh();
      syncServerContext(syncHeaderMobileMenu);
    }, 150);
  });
  document.addEventListener('cart:rerendered', function () {
    window.setTimeout(function () {
      scheduleRefresh();
      syncServerContext(syncHeaderMobileMenu);
    }, 150);
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && (e.target.closest('[data-action="toggle-mini-cart"]') || e.target.closest('.header__cart-icon') || e.target.closest('.header__cart-toggle') || e.target.closest('[data-action="toggle-mobile-menu"]') || e.target.closest('.header__mobile-nav-toggle') || e.target.closest('[data-action="toggle-menu"]'))) {
      window.setTimeout(function () {
        scheduleRefresh();
        if (document.querySelector('[data-clear-ks]')) {
          syncServerContext(syncHeaderMobileMenu);
        }
      }, 120);
    }
  });

  var observer = new MutationObserver(function () {
    scheduleRefresh();
  });

  function init() {
    syncServerContext();
    var root = document.getElementById('mini-cart');
    if (root) {
      observer.observe(root.parentNode || root, { childList: true, subtree: true });
    }
    var cartSection = document.querySelector('[data-section-type="cart"]');
    if (cartSection) {
      observer.observe(cartSection, { childList: true, subtree: true });
    }
    window.setTimeout(scheduleRefresh, 120);
    window.addEventListener('resize', scheduleRefresh, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
